<script setup>
import LiteYouTubeEmbed from 'vue-lite-youtube-embed';
import 'vue-lite-youtube-embed/style.css';
</script>

<template>
  <LiteYouTubeEmbed id="{{ id }}" title="{{ title }}" :webp="true" params="start=0&cc_load_policy=1&cc_lang_pref=en" />
</template>
